export default __webpack_public_path__ + "static/1-a894db35a9e9e45fbc43b577972995d6.jpg";